/**
 * Единый источник вопросов/ответов для /faq (UI + JSON-LD FAQPage).
 * answerPlain должен совпадать по смыслу с видимым текстом на странице.
 */
export const MARKETING_FAQ_QA = [
  {
    id: 'install',
    question: 'Нужна ли установка?',
    answerPlain:
      'preztimer — это веб-сервис в браузере на компьютере, планшете или телефоне. Отдельной программы и офлайн-режима нет.',
  },
  {
    id: 'guest',
    question: 'Можно начать без аккаунта?',
    answerPlain:
      'Да. Комната — это рабочее пространство на мероприятие: с главной создаётся гостевая комната, панель управления открывается сразу по ссылке.',
  },
  {
    id: 'other-device',
    question: 'Можно ли управлять таймером с другого устройства?',
    answerPlain:
      'Да. Откройте ту же панель управления в браузере на другом компьютере или планшете — при активной сессии и доступе к комнате управление с любого разрешённого устройства такое же, как с первого.',
  },
  {
    id: 'webinars',
    question: 'Подходит ли preztimer для вебинаров?',
    answerPlain:
      'Да, если нужен общий тайминг и подсказки спикеру: панель у продюсера, ссылка на экран таймера — у ведущего или в сцене трансляции. Зрителям в чате сервис сигналы не рассылает — это делает платформа вебинара.',
  },
  {
    id: 'viewer',
    question: 'Как спикер видит таймер?',
    answerPlain:
      'Экран таймера — это полноэкранная страница по ссылке (/viewer/…) или QR из панели управления. Спикер открывает её на своём устройстве или на мониторе в зале.',
  },
  {
    id: 'timer-modes',
    question: 'Какие режимы у таймера?',
    answerPlain:
      'Обратный отсчёт, прямой отсчёт, часы. Формат 12 или 24 часа задаётся в настройках комнаты.',
  },
  {
    id: 'multi-device-time',
    question: 'Как считается время на разных устройствах?',
    answerPlain:
      'Каждое устройство показывает время по своему браузеру. На площадке открывайте панель и экран таймера на машинах с нужным для вас временем.',
  },
  {
    id: 'audience-questions',
    question: 'Зрители могут присылать вопросы на экран?',
    answerPlain:
      'Нет отдельной формы для зала. Сообщения на экран таймера готовит и включает команда с панели управления.',
  },
  {
    id: 'automation',
    question: 'Есть ли автозапуск по расписанию или цепочка таймеров?',
    answerPlain: 'Нет. Старт, пауза и переход к следующему таймеру — вручную с панели управления.',
  },
  {
    id: 'offline-api',
    question: 'Есть ли офлайн или публичный API?',
    answerPlain:
      'Нет. Управление только через сайт в браузере; внешнего HTTP API для скриптов и пультов нет.',
  },
  {
    id: 'embed-site',
    question: 'Можно ли встроить таймер на свой сайт через iframe или виджет?',
    answerPlain:
      'Нет. Встраивания страницы preztimer в чужой сайт через iframe нет: используйте ссылку на экран таймера или QR и откройте отсчёт в отдельном окне или на отдельном мониторе. Подробнее — в гайде «Таймер на сайте: ссылка на экран вместо iframe».',
  },
  {
    id: 'internet-outage',
    question: 'Что если пропадёт интернет?',
    answerPlain:
      'Без сети панель и экран не синхронизируются. На площадке стоит иметь запасной канал связи.',
  },
  {
    id: 'free-tier',
    question: 'Что доступно по лицензии Базовый?',
    answerPlain:
      'Лимиты: до 3 комнат у владельца, до 3 таймеров и 3 карточек сообщений в комнате, до 3 одновременных подключений. Данные не удаляются — сверх лимита доступ закрывается до расширения лицензии. Цены.',
  },
  {
    id: 'free-vs-no-limits-marketing',
    question: 'Почему у других таймеров пишут «бесплатно без лимитов», а у вас лимиты на Базовом?',
    answerPlain:
      'Часто «без лимитов» относится к простому счётчику на странице без комнаты, команды и отдельного экрана таймера. По лицензии Базовый в preztimer лимиты явные: до 3 комнат у владельца, до 3 таймеров и 3 карточек сообщений в комнате, до 3 одновременных подключений — см. таблицу на странице «Цены». Базовый не является пробным периодом; расширение — лицензия Профи.',
  },
] as const;

export type MarketingFaqEntry = (typeof MARKETING_FAQ_QA)[number];
